var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UIButton", {
        attrs: {
          buttonText: "Add project",
          id: "addProject",
          size: _vm.buttonSize,
          variant: _vm.variant,
          fullWidth: _vm.fullWidthTrigger,
        },
        on: { click: _vm.showModal },
        scopedSlots: _vm._u(
          [
            !_vm.withoutIcon
              ? {
                  key: "icon",
                  fn: function () {
                    return [
                      _vm.isIconShown
                        ? _c("PlusIcon", {
                            staticClass: "text-white fill-current w-2.5 h-2.5",
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              contractorId: _vm.contractorId,
              currentUserRole: _vm.currentUserRole,
              companyId: _vm.companyId,
            },
            on: {
              activityAdded: _vm.onActivityAdded,
              close: function ($event) {
                _vm.modalShown = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }